import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/DocumentationViewer'
import { localized } from '@/decorators/localized'
import { DocumentationTree } from '@/components/documentationViewer/content'

@localized()
class DocumentationViewer extends React.Component {
  componentDidMount () {
    this.props.loadTree()
  }
  render () {
    return (<DocumentationTree
      key={this.props.documentationViewer.componentKey}
      {...this.props}
    />)
  }
}

const mapStateToProps = (state, ownProps) => ({
  documentationViewer: state.documentationViewer,
  ...ownProps
})

const mapDispatchToProps = {
  loadTree: actionCreators.loadTree,
  download: actionCreators.download
}
export default connect(mapStateToProps, mapDispatchToProps)(DocumentationViewer)



// WEBPACK FOOTER //
// ./src/report-app/pages/documentation/index.js